import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import Box from '@material-ui/core/Box';
import FactoidCard from 'containers/FAQ/components/FactoidCard';
import Divider from '@material-ui/core/Divider';
import ActionButtons from './ActionButtons';
import TaggedTopics from './TaggedTopics';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '49px 46px',
    [theme.breakpoints.down('md')]: {
      padding: '40px 25px',
    },
  },
  divider: {
    marginTop: 22,
  },
}));

function ResourcePageLeftPanel({ data, bottomNode }) {
  const classes = useStyles();
  const clientDetails = useSelector(makeSelectClientDetails());
  const acceptedTopics = _get(data, 'acceptedTopics', []);
  const withFactiod =
    _get(data, 'resourceData.items.0.sys.contentType.sys.id') === 'source' &&
    _get(data, 'resourceData.items.0.fields.type') === 'FAQ';
  const resourceData = _get(data, 'resourceData', {});
  const actionProps = _get(data, 'actionProps', {});
  const shouldShowActionsButtons = !_get(
    clientDetails,
    'metadata.hideLeftPanelActions',
    false,
  );

  return (
    <Box display="flex" className={classes.root} flexDirection="column">
      {shouldShowActionsButtons && (
        <>
          <ActionButtons data={{ resourceData, actionProps }} />
          <Divider className={classes.divider} />
        </>
      )}
      <TaggedTopics data={acceptedTopics} />
      {bottomNode}
      {withFactiod && (
        <FactoidCard
          data={acceptedTopics}
          topicName={_get(data, 'data.fields.title')}
        />
      )}
    </Box>
  );
}

ResourcePageLeftPanel.propTypes = {
  data: PropTypes.object,
};

export default ResourcePageLeftPanel;
